import type { ProductPublicDto } from "@sticker-giant/sg-frontend-common";
import { useQuery } from "@tanstack/react-query";
import { usePdpParams } from "@/providers/PdpParamsProvider";
import { useServicesStore } from "@/stores/useServicesStore";
export const PRODUCT_QUERY_OPTIONS = {
  includeChildren: true,
  fetchRatingSummary: true
} as const;
export const getProductQueryKey = (sku?: string, startingQuantity?: number) => ["product", sku, PRODUCT_QUERY_OPTIONS.includeChildren, PRODUCT_QUERY_OPTIONS.fetchRatingSummary, startingQuantity] as const;
export const useProduct = (sku?: string) => {
  const {
    productClientPublic
  } = useServicesStore.getState();
  const {
    quantity: startingQuantity
  } = usePdpParams();
  return useQuery<ProductPublicDto>({
    queryKey: getProductQueryKey(sku, startingQuantity),
    enabled: Boolean(productClientPublic) && Boolean(sku),
    queryFn: async () => {
      if (!productClientPublic || !sku) {
        throw new Error("Product client is not available or SKU is missing.");
      }
      return await productClientPublic.getProductBySku({
        sku,
        includeChildren: PRODUCT_QUERY_OPTIONS.includeChildren,
        fetchRatingSummary: PRODUCT_QUERY_OPTIONS.fetchRatingSummary,
        startingQuantity
      });
    }
  });
};